import {HashTab} from "./HashTab";

export const EmptyHashTab: HashTab = () => {
  return null;
};
